import clsx from 'clsx';
import styles from 'components/UI/V3/Dropdown/Header/DropdownHeader.module.scss';
import React from 'react';

interface DropdownHeaderProps {
    children: React.ReactNode;
    className?: string;
}

export const DropdownHeader: React.FC<DropdownHeaderProps> = ({ children, className }) => {
    return <div className={clsx(styles.root, className)}>{children}</div>;
};
